<template>
  <div class="row mt-4 ms-1 me-1">
    <section-header>Potencjalne przyczyny</section-header>
    <p v-html="causes" class="causes mt-2 list-p-margin"></p>
  </div>
</template>
<script>
import SectionHeader from "@/components/fault-detail-components/SectionHeader";
export default {
  components: { SectionHeader },
  props: {
    causes: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.causes {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}
</style>
